import { AIButtonTextGrey as AIButtonTextGreyButton } from '../../AIButton'
import { BUTTON_HEIGHT_24 } from '../../Button'
import { Container } from '../Container'

import PlusIcon from '../../../icons/plus.svg'

const AI_TEXT_GREY_BUTTON_SIZES = [BUTTON_HEIGHT_24]

const AI_TEXT_GREY_ICON_SIZES = [BUTTON_HEIGHT_24]

export function AIButtonTextGrey() {
  return (
    <>
      <Container label='AI Button, text grey, sizes - 24px'>
        {AI_TEXT_GREY_BUTTON_SIZES.map(size => (
          <AIButtonTextGreyButton height={size} key={size} text='Button' />
        ))}
      </Container>
      <Container label='AI Button, text grey, disabled, sizes - 24px'>
        {AI_TEXT_GREY_BUTTON_SIZES.map(size => (
          <AIButtonTextGreyButton
            disabled
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='AI Button, text grey, with loader, sizes - 24px'>
        {AI_TEXT_GREY_BUTTON_SIZES.map(size => (
          <AIButtonTextGreyButton
            isLoading
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='AI Button, text grey, with pre icon, sizes - 24px'>
        {AI_TEXT_GREY_BUTTON_SIZES.map(size => (
          <AIButtonTextGreyButton
            beforeIconProps={{ Icon: PlusIcon }}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='AI Button, text grey, with pre icon, with loader, sizes - 24px'>
        {AI_TEXT_GREY_BUTTON_SIZES.map(size => (
          <AIButtonTextGreyButton
            isLoading
            beforeIconProps={{ Icon: PlusIcon }}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='AI Button, text grey, with post icon, sizes - 24px'>
        {AI_TEXT_GREY_BUTTON_SIZES.map(size => (
          <AIButtonTextGreyButton
            afterIconProps={{ Icon: PlusIcon }}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='AI Button, text grey, with post icon, with loader, sizes - 24px'>
        {AI_TEXT_GREY_BUTTON_SIZES.map(size => (
          <AIButtonTextGreyButton
            isLoading
            afterIconProps={{ Icon: PlusIcon }}
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='AI Button, text grey, with skeleton, sizes - 24px'>
        {AI_TEXT_GREY_BUTTON_SIZES.map(size => (
          <AIButtonTextGreyButton
            isSkeleton
            height={size}
            key={size}
            text='Button'
          />
        ))}
      </Container>
      <Container label='AI Button, text grey, icon, sizes - 24px'>
        {AI_TEXT_GREY_ICON_SIZES.map(size => (
          <AIButtonTextGreyButton
            beforeIconProps={{ Icon: PlusIcon }}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='AI Button, text grey, icon, disabled, sizes - 24px'>
        {AI_TEXT_GREY_ICON_SIZES.map(size => (
          <AIButtonTextGreyButton
            disabled
            beforeIconProps={{ Icon: PlusIcon }}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='AI Button, text grey, icon, with loader, sizes - 24px'>
        {AI_TEXT_GREY_ICON_SIZES.map(size => (
          <AIButtonTextGreyButton
            isLoading
            beforeIconProps={{ Icon: PlusIcon }}
            height={size}
            key={size}
          />
        ))}
      </Container>
      <Container label='AI Button, text grey, icon, with skeleton, sizes - 24px'>
        {AI_TEXT_GREY_ICON_SIZES.map(size => (
          <AIButtonTextGreyButton
            isSkeleton
            beforeIconProps={{ Icon: PlusIcon }}
            height={size}
            key={size}
          />
        ))}
      </Container>
    </>
  )
}
